import { render, staticRenderFns } from "./TranscriptEditor.vue?vue&type=template&id=c440a150&scoped=true&"
import script from "./TranscriptEditor.vue?vue&type=script&lang=ts&"
export * from "./TranscriptEditor.vue?vue&type=script&lang=ts&"
import style0 from "./TranscriptEditor.vue?vue&type=style&index=0&id=c440a150&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c440a150",
  null
  
)

export default component.exports